import type { MountingKit, Product } from "@/features/sub-families/types";
import type { Nullable } from "@/types";

export const getMountingKits = (product: Nullable<Product>) => {
    return product?.properties.ceiling_meta_data ?? [];
};

export function getMountingKitByConfigCode(
    product: Nullable<Product>,
    configCode: Nullable<string>,
): Nullable<MountingKit> {
    if (configCode === null) return null;

    return getMountingKits(product).find((mountingKit) => mountingKit.configCode === configCode) ?? null;
}
